/*=========================================================================================
  File Name: moduleCompanyGetters.js
  Description: Company Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	getUploadItemId: (state) => (uploadId) => {
		const uploadFound = state.uploadedFiles.find((event) => event.id === parseInt(uploadId));
		return uploadFound;
	},
};
